import { computed } from 'vue';
import { useStore } from 'vuex';
import { storeToRefs } from 'pinia';
import { useFormulaStore } from '@/store/formula/formula';
// for checking shared or company type
import { SharedTypes } from '../enums';

const useFormulaComposable = () => {
    const store = useStore();
    const company_id = computed(() => {
        return store.getters['auth/userCompanyId'];
    });

    const { formula, formulas, totalFormulas } = storeToRefs(useFormulaStore());
    const { fetchAllFormulas, createFormula, updateFormula, fetchFormulaById, deleteFormulaById, exportCompanyToShared, importSharedToCompany, testFormula } = useFormulaStore();

    const fetchFormulas = async (shared, pageable, pageList) => {
        if (shared == SharedTypes.SHARED) {
            await fetchAllFormulas(null, pageable, pageList);
        } else {
            await fetchAllFormulas(company_id.value?.id, pageable, pageList);
        }
    };

    const addFormula = async (shared, body) => {
        await createFormula(shared == SharedTypes.COMPANY ? { ...body, company_id: company_id.value?.id } : body);
    };

    const fetchFormula = async (id, shared) => {
        if (shared == SharedTypes.SHARED) {
            await fetchFormulaById(id);
        } else {
            await fetchFormulaById(id, company_id.value?.id);
        }
    };

    const exportToShared = async (formula_id) => {
        await exportCompanyToShared(formula_id, company_id.value?.id);
    };

    const importToCompany = async (formula_id) => {
        await importSharedToCompany(formula_id, company_id.value?.id);
    };

    const deleteFormula = async (formula_id, shared) => {
        await deleteFormulaById(formula_id, shared == SharedTypes.SHARED ? null : company_id.value?.id);
    };

    return {
        formula,
        formulas,
        fetchFormulas,
        addFormula,
        fetchFormula,
        updateFormula,
        deleteFormula,
        exportToShared,
        importToCompany,
        testFormula,
        totalFormulas,
    };
};

export default useFormulaComposable;
